"use client"

import { Skeleton } from "@/components/ui/skeleton"

const BreakingPostsSkeleton = () => {
  return (
    <div className="flex flex-col w-full sm:gap-4 gap-5">
      <Skeleton className="h-5 w-32 rounded" />
      <div className="flex flex-col gap-0 max-h-[700px] overflow-y-auto">
        {Array.from({ length: 5 }).map((_, idx) => (
          <div key={idx} className="flex flex-col">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-6 w-full rounded" />
              <div className="flex flex-row sm:gap-4 gap-3">
                <Skeleton className="w-[150px] h-[100px] rounded flex-shrink-0" />
                <div className="flex flex-col justify-start gap-2 flex-1">
                  <Skeleton className="h-4 w-full rounded" />
                  <Skeleton className="h-4 w-5/6 rounded" />
                  <Skeleton className="h-3 w-20 rounded mt-1" />
                </div>
              </div>
            </div>
            {idx < 4 && <div className="border-b border-dashed border-[#ced4da] sm:my-[26px] my-4"></div>}
          </div>
        ))}
      </div>
    </div>
  )
}

export default BreakingPostsSkeleton
